export function getUserLinkUrl(linkName: string) {
  return {
    development: `http://localhost:5000/api/atira-link/static/${linkName}`,
    production: `https://atrl.ink/${linkName}`,
    staging: `https://staging.atiralink.com/api/atira-link/static/${linkName}`,
  }[process.env.REACT_APP_ENV!]!;
}
